import axios from 'axios'


interface Response {
  status: string
  data: any
}


export const IdealProfile = async (token: string, userTestId: number) => {

  const apiTest = `${process.env.REACT_APP_MAIN_API}/compentece/results/group/${userTestId}?limit=1000&ideal_profile=true`

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }

  const response: Response = await axios.get(apiTest, config).then((res) => {
    return res.data
  }).catch((err) => {
    return err
  })

  return response
}
